import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-login-forgot-password-reset',
  templateUrl: './forgot-password-reset.component.html',
  styleUrls: ['../login.component.css', './forgot-password-reset.component.css'],
  standalone: false,
})
export class ForgotPasswordResetComponent {
  // Context bridge to parent login component
  @Input() ctx: any;
  @Input() loading = false;

  constructor(public theme: ThemeService) {}
}
